export default __webpack_public_path__ + "static/media/20.07dfa5c2.mp4";